import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Col, Row } from "react-bootstrap";
import "react-datepicker/dist/react-datepicker.css";
import { Link, useLocation } from "react-router-dom";
import Select from "react-select";
import { ENDPOINT } from "../../axios/apiConfig";
import { getData, postData } from "../../axios/apiHelper";
import { loader } from "../../loader";
import DatePicker from "react-datepicker";
import CommonModel from "../../Model/CommonModel";
let path_image = process.env.REACT_APP_ASSETS_PATH_INFORMED_DESIGN;
const OneSourceForm = ({type}) => {
  const accountType =type;
  const titleFieldRef = useRef(null);
  const [id] = useState( accountType == "vwd" ? "FOkB/AUT2wGXRv ablqvbg==" : localStorage.getItem("user_id"));
  const location = useLocation();
  const [ageGroups, setAgeGroups] = useState([]);
  const [categories, setCategories] = useState([]);
  const [allPdfData, setAllPdfData] = useState(null);
  const currentDate = new Date();
  const state = location?.state || {};
  const navigate = useNavigate();
  const [commanShow, setCommanShow] = useState(false);

  const product = [
    {
      label: "Product name",
      type: "input",
      placeholder: "Type your product name",
    },
  ];

  const [userInputs, setCreateLibraryInputs] = useState({
    expDatetime: new Date(
      moment(new Date(), "MM/DD/YYYY").add(1, "years").format("MM/DD/YYYY")
    ),
    contentTitle: "",
    journalTitle: "",
    allowShare: true,
    allowDownload: true,
    product: "d",
    category: "",
    ibu: "",
    associatedAge: [],
    associatedTouchpoint: [],
    hideHCP: false,
    femaleOriented: false,
    creation_date: "",
  });

  const [userDetail, setUserDetail] = useState({
    user: {},
    production: [],
    pharmaArr: [],
    sales: [],
    country: [],
    format: [],
    product: [],
    hcp: [
      "Principal Investigator",
      "Sub-Investigator",
      "Study Coordinator",
      "Study Nurse",
      "Other",
    ],
  });

  const handleModelFun = (e) => {
    setUserDetail({ ...userDetail, newValue: e.target.value });
  };

  const handleSubmitModelFun = async (e) => {
    try {
      let body = {
        user_id: id,
        product: userDetail?.newValue,
        category: 0,
        type: 1,
      };
      await postData(ENDPOINT.ADD_SPC_PRODUCT, body);
      let newAr = userDetail?.product;
      newAr.push({ value: userDetail?.newValu, label: userDetail?.newValue });
      setCreateLibraryInputs({
        ...userInputs,
        product: { value: userDetail?.newValue, label: userDetail?.newValue },
      });
      setUserDetail({ ...userDetail, product: newAr });
    } catch (err) {
      console.log("err", err);
    }
  };

  const [errors, setErrors] = useState({});

  const initalFun = async () => {
    loader("show");
    try {
      let reqpaload = {
        user_id: id,
        irt: location?.state?.flag == "mandatory" ? 1 : 0,
      };
      const hadData = await postData(ENDPOINT.LIBRARYDETAIL, reqpaload);

      let country = [];
      if (hadData?.data?.data?.country?.length) {
        if (typeof hadData?.data?.data?.country == "string") {
          JSON.parse(hadData?.data?.data?.country)?.forEach((key) => {
            country.push({ label: key, value: key });
          });
        } else {
          hadData?.data?.data?.country?.forEach((key) => {
            country.push({ label: key, value: key });
          });
        }
      }

      let category = [];
      if (hadData?.data?.data?.category?.length) {
        hadData?.data?.data?.category?.forEach((key) => {
          category.push({ label: key, value: key });
        });
      }

      setUserDetail({
        ...userDetail,
        user: hadData?.data?.data?.user,
        production: hadData?.data?.data?.production,
        pharmaArr: hadData?.data?.data?.pharma_arr,
        country: country,
        costCenter: hadData?.data?.data?.costCenter,
        sales: hadData?.data?.data?.sale,
        format: hadData?.data?.data?.format,
        category: category,
        ibu: hadData?.data?.data?.ibu,
        product: hadData?.data?.data?.product,
        reseller: hadData?.data?.data?.reseller,
        trial: [{ label: "LEXx210", value: "3972" }],
      });

      loader("hide");
    } catch (err) {
      loader("hide");
    }
  };
  
 useEffect(() => {
  if (!userDetail?.category?.length) return;

  setCreateLibraryInputs((prev) => {
    if (!prev.category) return prev;

    const matched = userDetail.category.find(
      (opt) =>
        opt.value === prev.category ||
        opt.value === prev.category?.value
    );

    return {
      ...prev,
      category: matched ? matched : "",
    };
  });
}, [userDetail?.category]);


  const libraryDetail = async () => {
    try {
      loader("show");
      const hadData = await getData(
        `${ENDPOINT.LIBRARY_DETAIL_BY_ID}/${state?.pdfid}`
      );
      const details = hadData?.data?.data?.pdfData;

      if (details) {
        setCreateLibraryInputs((prev) => {
          let touchpoint = parseIfString(details.diagnosis);
          let ageGroups = parseIfString(details.age_groups);
          if (touchpoint.length === 8) touchpoint = ["All", ...touchpoint];
          if (ageGroups.length === 5) ageGroups = ["All", ...ageGroups];

          const assignableObject = {
            ...prev,
            contentTitle: details.contentTitle || "",
            journalTitle: details.pdf_sub_title || "",
            category: details.category
              ? { label: details.category, value: details.category }
              : "",
            product: details.product
              ? { label: details.product, value: details.product }
              : "",
            associatedTouchpoint: touchpoint || [],
            associatedAge: ageGroups || [],
            hideHCP: details.sold_unsold_status ?? false,
            femaleOriented: details.female_oriented ?? false,
            creation_date: details.creation_date
              ? new Date(details.creation_date)
              : "",
          };
          return assignableObject;
        });

        setAllPdfData(details);
      }
    } catch (err) {
      console.log("-err", err);
    } finally {
      loader("hide");
    }
  };

  const addNewProductClicked = (e) => {
    e.preventDefault();
    setCommanShow(true);
  };

  useEffect(() => {
    libraryDetail();
    initalFun();
    if (id === "FOkB/AUT2wGXRv ablqvbg==") {
      fetchAgeCategoriesData();
    }
  }, []);

  const handleChange = (e, isSelectedName) => {
    setCreateLibraryInputs({
      ...userInputs,
      [isSelectedName ? isSelectedName : e?.target?.name]: isSelectedName
        ? e
        : e?.target?.value,
    });
  };

  // ✅ validation function
  const validateForm = () => {
    let newErrors = {};
    if (!userInputs.contentTitle.trim())
      newErrors.contentTitle = "Content title is required";
    if (!userInputs.journalTitle.trim())
      newErrors.journalTitle = "Subtitle is required";
    if (!userInputs.category) newErrors.category = "Category is required";
    if (!userInputs.product) newErrors.product = "Product is required";
    if (!userInputs.creation_date)
      newErrors.creation_date = "Creation date is required";
    if (!userInputs.associatedAge.length)
      newErrors.associatedAge = "At least one age group is required";
    if (!userInputs.associatedTouchpoint.length)
      newErrors.associatedTouchpoint = "At least one touchpoint is required";


      setErrors(newErrors);
       setTimeout(() => {
                const firstErrorDiv = document.querySelector('.login-validation');
                    if (firstErrorDiv) {
                        firstErrorDiv.scrollIntoView({ behavior: 'smooth', block: 'center' });
                      }
                    }, 100);
          return Object.keys(newErrors).length === 0;
       };

  const parseIfString = (val) => {
    if (Array.isArray(val)) return val;
    if (typeof val === "string") {
      try {
        const parsed = JSON.parse(val);
        return Array.isArray(parsed) ? parsed : [];
      } catch {
        return [];
      }
    }
    return [];
  };

  const nextButtonClicked = async () => {
    if (!validateForm()) {
      return;
    }
    loader("show");

    const isocrDate = userInputs?.creation_date
      ? moment(userInputs.creation_date).format("YYYY-MM-DD")
      : "";

    try {
        const payload = {
          associatedTouchpoint: parseIfString(userInputs?.associatedTouchpoint).filter(item =>item!== "All"),
          associatedAge: parseIfString(userInputs?.associatedAge).filter(item =>item!== "All"),
          journalTitle : userInputs?.journalTitle || "",
          category: userInputs?.category?.value || "",
          product: userInputs?.product?.value || "",
          hideHCP: false,
          femaleOriented: userInputs?.femaleOriented == 1 || userInputs?.femaleOriented ? true : false,
          creation_date: isocrDate || "",
          pdfId: state?.pdfid,
          isEdit: state?.isEdit && state?.isEdit == true ? 1 : 0,
          ...((accountType == "vwd") && { isVwd: true })
        };
       const result = await postData(ENDPOINT.LIBRARYCLONEONESOURCE, payload);
        navigate(accountType == "vwd" ? "/vwd/content-detail" : "/narrative/content-detail", {
          state: {
            pdfId: result?.data?.data?.pdf_id,
            isEdit: state?.isEdit && state?.isEdit == true ? 1 : 0,
            onesourceClone: 1,
          },
        });
    } catch (err) {
      console.error(err);
    } finally {
      loader("hide");
    }
  };

  const fetchAgeCategoriesData = async () => {
    try {
      loader("show");
      const res = await getData(ENDPOINT.CATEGORIES_AGE_GROUP);
      setAgeGroups(res?.data?.data?.ageGroups || []);
      setCategories(res?.data?.data?.categories || []);
    } catch (err) {
      console.error("Error fetching data:", err);
    } finally {
      loader("hide");
    }
  };

  const ErrorMessage = ({ message }) =>
    message ? <div className="login-validation">{message}</div> : null;

  const [categoriesOptions, setCategoriesOptions] = useState(userDetail?.category || []);
  const selectedCategory = useMemo(() => {categoriesOptions.find(
    (opt) => opt.value === userInputs?.category?.value
  )}, [userInputs, categoriesOptions]);
  const docintelLink = () => {
    return (
      <div className="create-change-content wilprophy">
        <div className="form_action">
          <h4>About the Docintel link you're making</h4>
          <div className="row">
            <div className="col-12 col-md-12">
              <div className="form-group">
                <label>
                  Category <span>*</span>
                </label>
                <Select
                  // options={userDetail?.category}
                  // value={userInputs?.category || null}
                  options={categoriesOptions}
                  value={selectedCategory || null}
                  placeholder="Select category type for users to sort"
                  onChange={(e) => handleChange(e, "category")}
                  className={
                    errors?.category
                      ? "dropdown-basic-button split-button-dropup error"
                      : "dropdown-basic-button split-button-dropup"
                  }
                  isClearable
                />
                <ErrorMessage message={errors.category} />
              </div>

              <div className="form-group margin-added">
                <label>
                  Product <span>*</span>
                </label>
                <Select
                  options={userDetail?.product}
                  value={userInputs?.product || null}
                  placeholder="Select the product this is for"
                  onChange={(e) => handleChange(e, "product")}
                  className={
                    errors?.product
                      ? "dropdown-basic-button split-button-dropup error"
                      : "dropdown-basic-button split-button-dropup"
                  }
                  isClearable
                />
                <ErrorMessage message={errors.product} />
              </div>

              <div className="form-group">
                <label>
                  Associated Age <span>*</span>
                </label>
                <fieldset id="group3">
                <div>
                      <label htmlFor="age-all">All</label>
                      <input
                        type="checkbox"
                        id="age-all"
                        value="All"
                        checked={userInputs?.associatedAge?.includes("All") || false}
                        onChange={(e) => handleAgeChange(e, "All", ageGroups)}
                      />

                    </div>
                  {ageGroups.map((age) => {
                    const associatedAge =
                          age.min_age === null && age.max_age === null
                            ? null
                            : age.max_age === null
                            ? `Age >${age.min_age}`
                            : age.min_age === 0
                            ? `Age <${age.max_age}`
                            : `Age ${age.min_age}-${age.max_age}`;
                    if (!associatedAge) return null;
                    // Disable condition for Age checkboxes
                    // const shouldDisable =
                    //   (userInputs?.associatedTouchpoint?.includes(
                    //     "Pregnancy & Childbirth"
                    //   ) &&
                    //     (associatedAge === "Age <6" ||
                    //       associatedAge === "Age 6-11")) ||
                    //   (userInputs?.associatedTouchpoint?.includes("HMB") &&
                    //     (associatedAge === "Age <6" ||
                    //       associatedAge === "Age 6-11"));

                    // // Skip rendering "All"
                    // if (associatedAge === "All") return null;

                    const specificAges = ["Age <6", "Age 6-11"];
                          const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
                          const selectedTouchpoints = userInputs?.associatedTouchpoint || [];

                          const anySpecificTP = selectedTouchpoints.some((tp) =>
                            specificTouchpoints.includes(tp)
                          );
                          const anyOtherTP = selectedTouchpoints.some(
                            (tp) => !specificTouchpoints.includes(tp)
                          );

                          const shouldDisable =
                            anySpecificTP && !anyOtherTP && specificAges.includes(associatedAge);

                          // NEW: remove disabled ages from state immediately
                          if (shouldDisable && userInputs?.associatedAge?.includes(associatedAge)) {
                            userInputs.associatedAge = userInputs.associatedAge.filter(
                              (a) => a !== associatedAge
                            );
                          }

                          const isChecked =
                            !shouldDisable && userInputs?.associatedAge?.includes(associatedAge);

                    return (
                      <div
                        key={age.id}
                        className={shouldDisable ? "disabled" : ""}
                      >
                        <label htmlFor={`age-${age.id}`}>{associatedAge}</label>
                        <input
                          type="checkbox"
                          value={associatedAge}
                          id={`age-${age.id}`}
                          // checked={
                          //   userInputs?.associatedAge?.includes(
                          //     associatedAge
                          //   ) || false
                          // }
                          checked={isChecked || false}
                          disabled={shouldDisable}
                          onChange={(e) =>
                            handleAgeChange(e, associatedAge, ageGroups)
                          }
                        />
                      </div>
                    );
                  })}
                </fieldset>
                <ErrorMessage message={errors.associatedAge} />
              </div>

              <div className="form-group">
                <label>
                  Associated Touchpoint <span>*</span>
                </label>
                <fieldset id="group4">
                <div>
                <label htmlFor="cat-all">All</label>

                              <input
                                type="checkbox"
                                id="cat-all"
                                value="All"
                                checked={userInputs?.associatedTouchpoint?.includes("All") || false}
                                onChange={(e) => handleTouchpointChange(e, "All", categories)}
                              />
                            </div>
                  {categories.map((cat,index) => {
                    // Disable condition for Touchpoints
                    if(index == 0) return;
                    // const shouldDisable =
                    //   (cat.name === "Pregnancy & Childbirth" &&
                    //     (userInputs?.associatedAge?.includes("Age <6") ||
                    //       userInputs?.associatedAge?.includes("Age 6-11"))) ||
                    //   (cat.name === "HMB" &&
                    //     (userInputs?.associatedAge?.includes("Age <6") ||
                    //       userInputs?.associatedAge?.includes("Age 6-11")));

                    // // Skip rendering "All"
                    // if (cat.name === "All") return null;

                    const specificAges = ["Age <6", "Age 6-11"];
                      const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
                      const selectedAges = userInputs?.associatedAge || [];

                      const anySpecificAge = selectedAges.some((age) => specificAges.includes(age));
                      const anyOtherAge = selectedAges.some((age) => !specificAges.includes(age));

                      const shouldDisable =
                        anySpecificAge && !anyOtherAge && specificTouchpoints.includes(cat.name);

                      // Remove disabled touchpoints from state immediately
                      if (shouldDisable && userInputs?.associatedTouchpoint?.includes(cat.name)) {
                        userInputs.associatedTouchpoint = userInputs.associatedTouchpoint.filter(
                          (tp) => tp !== cat.name
                        );
                      }

                      const isChecked =
                        !shouldDisable && userInputs?.associatedTouchpoint?.includes(cat.name);

                    return (
                      <div
                        key={cat.id}
                        className={shouldDisable ? "disabled" : ""}
                      >
                        <label htmlFor={`cat-${cat.id}`}>{cat?.name}</label>
                        <input
                          type="checkbox"
                          value={cat.name}
                          id={`cat-${cat.id}`}
                          // checked={userInputs.associatedTouchpoint?.includes(
                          //   cat.name
                          // )}
                          checked={isChecked || false}
                          disabled={shouldDisable}
                          onChange={(e) =>
                            handleTouchpointChange(e, cat.name, categories)
                          }
                        />
                      </div>
                    );
                  })}
                </fieldset>
                <ErrorMessage message={errors.associatedTouchpoint} />
              </div>
              <div className="form-group">
                <label>
                  Female
                  <br />
                  oriented
                </label>
                <fieldset id="group5">
                  <div className="switch">
                    <label className="switch-light">
                      <input
                        type="checkbox"
                        id="femaleOrien"
                        checked={userInputs?.femaleOriented == "1" || userInputs?.femaleOriented == true}
                        onChange={(e) => {
                          handleChange(e.target?.checked, "femaleOriented");
                        }}
                      />
                      <span>
                        <span className="switch-btn active">No</span>
                        <span className="switch-btn">Yes</span>
                      </span>
                      <a className="btn"></a>
                    </label>
                  </div>
                </fieldset>
              </div>
{/*
              <div className="form-group">
                <label>
                  Hide in HCP
                  <br />
                  mode
                </label>
                <fieldset id="group5">
                  <div className="switch">
                    <label className="switch-light">
                      <input
                        type="checkbox"
                        id="hideinHCP"
                        onChange={(e) => {
                          handleChange(e.target?.checked, "hideHCP");
                        }}
                      />
                      <span>
                        <span className="switch-btn active">No</span>
                        <span className="switch-btn">Yes</span>
                      </span>
                      <a className="btn"></a>
                    </label>
                  </div>
                </fieldset>
              </div> */}
            </div>
          </div>
        </div>
      </div>
    );
  };

  // const handleAgeChange = (e, label, ageGroups) => {
  //   setCreateLibraryInputs((prev) => {
  //     let updatedLabels = [...(prev.associatedAge || [])];

  //     if (e.target.checked) {
  //       // Add if not already included
  //       if (!updatedLabels.includes(label)) {
  //         updatedLabels.push(label);
  //       }
  //     } else {
  //       // Remove if unchecked
  //       updatedLabels = updatedLabels.filter((l) => l !== label);
  //     }

  //     // Ensure order follows UI and keep only checked ones
  //   const ordered = ageGroups
  //     .map((age) =>
  //        age.min_age === null && age.max_age === null
  //                           ? null 
  //                           : age.max_age === null
  //                           ? `Age >${age.min_age}`
  //                           : age.min_age === 0
  //                           ? `Age <${age.max_age}`
  //                           : `Age ${age.min_age}-${age.max_age}`
  //     )
  //     .filter((ageLabel) => updatedLabels.includes(ageLabel));

  //   return { ...prev, associatedAge: ordered };

  //     // return { ...prev, associatedAge: updatedLabels };
  //   });
  // };

  // const handleTouchpointChange = (e, label, categories) => {
  //   const checked = e.target.checked;

  //   setCreateLibraryInputs((prev) => {
  //     let updatedLabels = [...(prev.associatedTouchpoint || [])];

  //     if (checked) {
  //       // Add if not already included
  //       if (!updatedLabels.includes(label)) {
  //         updatedLabels.push(label);
  //       }
  //     } else {
  //       // Remove if unchecked
  //       updatedLabels = updatedLabels.filter((l) => l !== label);
  //     }

  //      // Ensure order follows UI (categories order)
  //   const ordered = categories
  //     .map((cat, index) => {
  //       if (index === 0) return null; // since you skip first
  //       return cat.name;
  //     })
  //     .filter(Boolean) // remove null
  //     .filter((catName) => updatedLabels.includes(catName));

  //   return { ...prev, associatedTouchpoint: ordered };

  //     // return { ...prev, associatedTouchpoint: updatedLabels };
  //   });
  // };

const handleAgeChange = (e, label, ageGroups) => {
  setCreateLibraryInputs((prev) => {
    const specificAges = ["Age <6", "Age 6-11"];
    const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
    const selectedTouchpoints = prev.associatedTouchpoint || [];
    const selectedAgeGroups = prev.associatedAge || [];
    const availableAges = ageGroups
      .map((age) =>
        age.max_age === null && age.min_age === null
          ? null
          : age.max_age === null
          ? `Age >${age.min_age}`
          : age.min_age === 0
          ? `Age <${age.max_age}`
          : `Age ${age.min_age}-${age.max_age}`
      )
      .filter(Boolean);
    const availbleCategories = categories
      .map((item) => item.name)
      .filter((item) => item !== "Age-only");
    let updatedAges = [...selectedAgeGroups];
    let updatedTouchpoints = [...selectedTouchpoints];

    // age group setting
    if (label === "All") {
      if (e.target.checked) {
        if (
          (selectedTouchpoints.length == 2 &&
            selectedTouchpoints.includes("HMB") &&
            selectedTouchpoints.includes("Pregnancy & Childbirth")) ||
          (selectedTouchpoints.length == 1 &&
            (selectedTouchpoints.includes("HMB") ||
              selectedTouchpoints.includes("Pregnancy & Childbirth")))
        ) {
          updatedAges = [
            "All",
            ...availableAges.filter((item) => !specificAges.includes(item)),
          ];
        } else {
          updatedAges = ["All", ...availableAges];
        }
      } else {
        updatedAges = [];
      }
    } else {
      if (e.target.checked) {
        updatedAges = [...updatedAges, label];
        if(updatedAges.length === availableAges.length) updatedAges = ["All",...updatedAges]
      } else {
        updatedAges = updatedAges.filter((item) => item !== label && item !== "All");
      }
    }

    // touchpoints setting
    if (
      (updatedAges.length === 2 &&
        updatedAges.includes("Age <6") &&
        updatedAges.includes("Age 6-11")) ||
      (updatedAges.length === 1 &&
        (updatedAges.includes("Age <6") || updatedAges.includes("Age 6-11")))
    ) {
      updatedTouchpoints = updatedTouchpoints.filter(
        (item) => !specificTouchpoints.includes(item)
      );
    }
    else{
      if(updatedTouchpoints.includes("All")){
        updatedTouchpoints = ["All",...availbleCategories]
      }
    }
    return {
      ...prev,
      associatedAge: updatedAges,
      associatedTouchpoint: updatedTouchpoints,
    };
  })}

  // const handleAgeChange = (e, label, ageGroups) => {
  //   setCreateLibraryInputs((prev) => {
  //     const specificAges = ["Age <6", "Age 6-11"];
  //     const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
  //     const selectedTouchpoints = prev.associatedTouchpoint || [];

  //     // Determine current disable condition (only specific touchpoints selected)
  //     const anySpecificTP = selectedTouchpoints.some((tp) =>
  //       specificTouchpoints.includes(tp)
  //     );
  //     const anyOtherTP = selectedTouchpoints.some(
  //       (tp) => !specificTouchpoints.includes(tp)
  //     );
  //     const shouldDisableSpecificAges = anySpecificTP && !anyOtherTP;

  //     let updatedAges = [...(prev.associatedAge || [])];

  //     // Handle "All" option
  //     if (label === "All") {
  //       if (e.target.checked) {
  //         // Select all valid age labels
  //         const allLabels = ageGroups
  //           .map((age) =>
  //             age.max_age === null && age.min_age === null
  //               ? null
  //               : age.max_age === null
  //               ? `Age >${age.min_age}`
  //               : age.min_age === 0
  //               ? `Age <${age.max_age}`
  //               : `Age ${age.min_age}-${age.max_age}`
  //           )
  //           .filter(Boolean);
  //         updatedAges = ["All", ...allLabels];
  //       } else {
  //         updatedAges = [];
  //       }
  //     } else {
  //       // Remove "All" if a specific age changed
  //       updatedAges = updatedAges.filter((a) => a !== "All");

  //       if (e.target.checked) {
  //         if (!(shouldDisableSpecificAges && specificAges.includes(label))) {
  //           updatedAges.push(label);
  //         }
  //       } else {
  //         updatedAges = updatedAges.filter((a) => a !== label);
  //       }

  //       // Check if all individual ages are selected → mark as "All"
        // const totalAgeLabels = ageGroups
        //   .map((age) =>
        //     age.max_age === null && age.min_age === null
        //       ? null
        //       : age.max_age === null
        //       ? `Age >${age.min_age}`
        //       : age.min_age === 0
        //       ? `Age <${age.max_age}`
        //       : `Age ${age.min_age}-${age.max_age}`
        //   )
        //   .filter(Boolean);

  //       const allChecked =
  //         totalAgeLabels.length > 0 &&
  //         totalAgeLabels.every((l) => updatedAges.includes(l));

  //       if (allChecked) updatedAges = ["All", ...totalAgeLabels];
  //     }

  //     // 🚫 If only specific ages selected → disable HMB & Pregnancy & Childbirth
  //     const onlySpecificAgesSelected =
  //       specificAges.every((a) => updatedAges.includes(a)) &&
  //       updatedAges.filter((a) => specificAges.includes(a)).length === 2 &&
  //       updatedAges.length === 2;

  //     let updatedTouchpoints = [...selectedTouchpoints];
  //     console.log(updatedTouchpoints,"updatedTouchpoints")
  //     if (onlySpecificAgesSelected) {
  //       updatedTouchpoints = updatedTouchpoints.filter(
  //         (tp) => !specificTouchpoints.includes(tp)
  //       );
  //     }

  //     return {
  //       ...prev,
  //       associatedAge: updatedAges,
  //       associatedTouchpoint: updatedTouchpoints,
  //     };
  //   });
  // };

  const handleTouchpointChange = (e, label, categories) => {
    setCreateLibraryInputs((prev) => {
      const specificAges = ["Age <6", "Age 6-11"];
      const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
      const selectedTouchpoints = prev.associatedTouchpoint || [];
      const selectedAgeGroups = prev.associatedAge || [];
      const availableAges = ageGroups
        .map((age) =>
          age.max_age === null && age.min_age === null
            ? null
            : age.max_age === null
            ? `Age >${age.min_age}`
            : age.min_age === 0
            ? `Age <${age.max_age}`
            : `Age ${age.min_age}-${age.max_age}`
        )
        .filter(Boolean);
      const availbleCategories = categories
        .map((item) => item.name)
        .filter((item) => item !== "Age-only");
      let updatedAges = [...selectedAgeGroups];
      let updatedTouchpoints = [...selectedTouchpoints];
      // categories setting

      if (label === "All") {
        if (e.target.checked) {
          if (
            (updatedAges.length === 2 &&
              updatedAges.includes("Age <6") &&
              updatedAges.includes("Age 6-11")) ||
            (updatedAges.length === 1 &&
              (updatedAges.includes("Age <6") ||
                updatedAges.includes("Age 6-11")))
          ) {
            updatedTouchpoints = [
              "All",
              ...availbleCategories.filter((item) => !specificTouchpoints.includes(item)),
            ];
          } else {
            updatedTouchpoints = ["All", ...availbleCategories];
          }
        } else {
          updatedTouchpoints = [];
        }
      } else {
        if (e.target.checked) {
          updatedTouchpoints = [...updatedTouchpoints, label];
          if(updatedTouchpoints.length === availbleCategories.length) updatedTouchpoints = ["All",...updatedTouchpoints]
        } else {
          updatedTouchpoints = updatedTouchpoints.filter((item) => item !== label && item !== "All");
        }
      }

      //age group setting
      if (
        (updatedTouchpoints.length == 2 &&
          updatedTouchpoints.includes("HMB") &&
          updatedTouchpoints.includes("Pregnancy & Childbirth")) ||
        (updatedTouchpoints.length == 1 &&
          (updatedTouchpoints.includes("HMB") ||
          updatedTouchpoints.includes("Pregnancy & Childbirth")))
      ) {
        updatedAges = updatedAges.filter(
          (item) => !specificAges.includes(item)
        );
      } else {
        if (updatedAges.includes("All")) {
          updatedAges = ["All", ...availableAges];
        }

      }

      return {
        ...prev,
        associatedTouchpoint: updatedTouchpoints,
        associatedAge: updatedAges,
      };
    });
  };

  // const handleTouchpointChange = (e, label, categories) => {
  //   setCreateLibraryInputs((prev) => {
  //     const specificAges = ["Age <6", "Age 6-11"];
  //     const specificTouchpoints = ["HMB", "Pregnancy & Childbirth"];
  //     const selectedAges = prev.associatedAge || [];

  //     // Determine disable condition (only specific ages selected)
  //     const anySpecificAge = selectedAges.some((age) =>
  //       specificAges.includes(age)
  //     );
  //     const anyOtherAge = selectedAges.some(
  //       (age) => !specificAges.includes(age)
  //     );
  //     const shouldDisableSpecificTPs = anySpecificAge && !anyOtherAge;

  //     let updatedTP = [...(prev.associatedTouchpoint || [])];

  //     // Handle "All" option
  //     if (label === "All") {
  //       if (e.target.checked) {
  //         // Select all valid touchpoints
  //         const allTPs = categories
  //           .map((cat, i) => (i === 0 ? null : cat.name))
  //           .filter(Boolean);
  //         updatedTP = ["All", ...allTPs];
  //       } else {
  //         updatedTP = [];
  //       }
  //     } else {
  //       // Remove "All" if a specific TP changed
  //       updatedTP = updatedTP.filter((tp) => tp !== "All");

  //       if (e.target.checked) {
  //         if (!(shouldDisableSpecificTPs && specificTouchpoints.includes(label))) {
  //           updatedTP.push(label);
  //         }
  //       } else {
  //         updatedTP = updatedTP.filter((tp) => tp !== label);
  //       }

  //       // Check if all individual TPs are selected → mark as "All"
  //       const totalTPs = categories
  //         .map((cat, i) => (i === 0 ? null : cat.name))
  //         .filter(Boolean);

  //       const allChecked =
  //         totalTPs.length > 0 && totalTPs.every((tp) => updatedTP.includes(tp));

  //       if (allChecked) updatedTP = ["All", ...totalTPs];
  //     }

  //     // 🚫 If only specific touchpoints are selected → disable/uncheck Age <6 & Age 6-11
  //     const onlySpecificTPsSelected =
  //       specificTouchpoints.every((tp) => updatedTP.includes(tp)) &&
  //       updatedTP.filter((tp) => specificTouchpoints.includes(tp)).length === 2 &&
  //       updatedTP.length === 2;

  //     let updatedAges = [...selectedAges];
  //     if (onlySpecificTPsSelected) {
  //       updatedAges = updatedAges.filter((age) => !specificAges.includes(age));
  //     }

  //     return {
  //       ...prev,
  //       associatedTouchpoint: updatedTP,
  //       associatedAge: updatedAges,
  //     };
  //   });
  // };

  return (
    <>
      <Col className="right-sidebar custom-change">
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <div className="custom-container">
          <Row>
            <div className="page-top-nav sticky">
              <Row className="justify-content-end align-items-center">
                <Col md={1}>
                  {state?.isEdit != true && (
                    <Link
                      className="btn btn-primary btn-bordered next"
                      to={accountType == "vwd" ? "/vwd/library-one-source-content" : "/library-one-source-content"} 
                      state={{
                        pdfId: state?.pdfid,
                      }}
                    >
                      Back
                    </Link>
                  )}
                </Col>
                <Col md={9}>
                  <ul className="tabnav-link">
                    <li>
                      <a href="">Select Your Content</a>
                    </li>
                    <li className="active active-main">
                      <a href="">Complete your content & publish</a>
                    </li>
                  </ul>
                </Col>
                <Col md={2}>
                  <div className="header-btn">
                    <Link
                      className="btn btn-primary btn-bordered move-draft cancel_btn"
                      to={
                        (state?.isEdit == true || state?.isEdit == 1) && accountType != "vwd"
                          ? "/library-content"
                          : (state?.isEdit == true || state?.isEdit == 1) && accountType == "vwd"
                          ? "/vwd/library"
                          : accountType == "vwd" ? "/vwd/library-add-content" : "/library-add-content"
                      }
                    >
                      Cancel
                    </Link>
                    <button
                      className="btn btn-primary btn-filled send_btn"
                      onClick={nextButtonClicked}
                    >
                      Publish
                    </button>
                  </div>
                </Col>
              </Row>
            </div>

            {docintelLink()}

            <div className="create-change-content wilprophy">
              <div className="form_action">
                <div className="d-flex align-items-center justify-content-between">
                  <h4>Creating the Docintel Link</h4>
                  <img
                    src={`${path_image}/one-source-logo.svg`}
                    alt="One Source Logo"
                  />
                </div>
                <Row>
                  <Col md={12}>
                    <div className="form-group val">
                      <label>
                        Content title <span>*</span>
                      </label>
                      <input
                        disabled
                        type="text"
                        name="contentTitle"
                        className={
                          errors?.contentTitle
                            ? "form-control disabled error"
                            : "form-control disabled"
                        }
                        value={userInputs?.contentTitle || ""}
                        onChange={(e) => handleChange(e)}
                      />
                      <ErrorMessage message={errors.contentTitle} />
                    </div>

                    <div className="form-group">
                      <label>
                        Subtitle <span>*</span>
                      </label>
                      <input
                        type="text"
                        name="journalTitle"
                        className={
                          errors?.journalTitle
                            ? "form-control error"
                            : "form-control"
                        }
                        value={userInputs?.journalTitle || ""}
                        onChange={(e) => handleChange(e)}
                      />
                      <ErrorMessage message={errors.journalTitle} />
                    </div>

                    <div className="form-group d-flex align-items-center event-date">
                      <label>
                        Creation date <span>*</span>
                      </label>
                      <DatePicker
                        name="creation_date"
                        className={
                          errors?.creation_date
                            ? "form-control error"
                            : "form-control"
                        }
                        minDate={currentDate}
                        autoComplete="off"
                        placeholderText="Select created date"
                        selected={
                          userInputs?.creation_date
                            ? new Date(userInputs.creation_date)
                            : null
                        }
                        onChange={(date) =>
                          setCreateLibraryInputs((prev) => ({
                            ...prev,
                            creation_date: date,
                          }))
                        }
                        dateFormat="dd/MM/yyyy"
                      />
                      <ErrorMessage message={errors.creation_date} />
                    </div>

                    <div className="form-group">
                      <label>Enable</label>
                      <fieldset id="group2">
                        <div className="disabled">
                          <label htmlFor="download">Download</label>
                          <input
                            disabled
                            checked={userInputs?.allowDownload}
                            type="checkbox"
                            id="download"
                          />
                        </div>
                        <div className="disabled">
                          <label htmlFor="share">Share</label>
                          <input
                            disabled
                            checked={userInputs?.allowShare}
                            type="checkbox"
                            id="share"
                          />
                        </div>
                      </fieldset>
                    </div>

                    <div
                      className="form-group"
                      style={{ alignItems: "flex-start" }}
                    >
                      <label>Content file</label>

                      {allPdfData &&
                        [allPdfData].map((data, index) => {
                          return (
                            <div className="col-12 mb-3" key={index}>
                              <div className="mail-content-select-box">
                                <div className="mail-content-select-top">
                                  <div className="mail-preview-img">
                                    <img src={data.coverImage} alt="Preview " />
                                  </div>
                                  <div className="mail-box-content">
                                    <h5>{data.title}</h5>
                                    <p>{data.pdf_sub_title}</p>
                                    <div className="mailbox-tags">
                                      <ul>
                                        {id === "FOkB/AUT2wGXRv ablqvbg==" ? (
                                                                                                    (() => {
                                                                                                      const parseJSONSafe = (json) => {
                                                                                                        try {
                                                                                                          return JSON.parse(json) || [];
                                                                                                        } catch (e) {
                                                                                                          return [];
                                                                                                        }
                                                                                                      };
                                                                                                      const combinedTags = [
                                                                                                        ...(data?.tags ? parseJSONSafe(data.tags).map(tag => ({ type: "clinical", name: tag })) : []),
                                                                                                        ...(data?.functional_tags ? parseJSONSafe(data.functional_tags).map(tag => ({ type: "functional", name: tag })) : []),
                                                                                                      ];
                                                                                                      // ✅ Sort alphabetically by tag name
                                                                                                      const sortedTags = combinedTags.sort((a, b) => a.name.localeCompare(b.name));
                                                                                                      return sortedTags.map((tag, index) => (
                                                                                                        <li
                                                                                                          key={index}
                                                                                                          className={`list1 ${tag.type === "clinical" ? "clinical" : "functional"}`}
                                                                                                          title={tag.type === "clinical" ? "Clinical" : "Functional"}
                                                                                                        >
                                                                                                          {tag.name}
                                                                                                        </li>
                                                                                                      ));
                                                                                                    })()
                                                                                                  ) : data?.tags && data.tags != ""  ? (
                                                                                                                data.tags.map((tag, index) => {
                                                                                                                return <li key={index} className="list1">{tag}</li>;
                                                                                                            })
                                                                                                  ) : <li className="list1">N/A</li>}
                                      </ul>
                                    </div>
                                  </div>
                                </div>

                                <div className="mail-content-table">
                                  <table>
                                    <tbody>
                                      <tr>
                                        <th>Upload date</th>
                                        <td>
                                          {data?.created_date
                                            ? data.created_date
                                            : "N/A"}
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>Language</th>
                                        <td>{data.language}</td>
                                      </tr>
                                      <tr>
                                        <th>Last email</th>
                                        <td>
                                          {data?.last_email_sent
                                            ? data.last_email_sent
                                            : "N/A"}
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                {
                                  <div className="mail-content-footer">
                                    {
                                      <a
                                        href={data.previewArticle}
                                        target="_blank"
                                      >
                                        <button className="btn btn-primary btn-filled">
                                          Preview
                                        </button>
                                      </a>
                                    }
                                  </div>
                                }
                              </div>
                            </div>
                          );
                        })} 
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Row>
        </div>
      </Col>

      <CommonModel
        show={commanShow}
        onClose={setCommanShow}
        heading={"Add New Product"}
        data={product}
        footerButton={"Add"}
        handleChange={handleModelFun}
        handleSubmit={handleSubmitModelFun}
      />
    </>
  );
};
export default OneSourceForm;
